<script>
  import { createEventDispatcher } from 'svelte';
  import { getApiUrl } from '../api';
  import { authFetch } from '../authService'; // <-- IMPORT THIS

  export let showModal = false;
  export let targetId;
  export let targetType; // 'promotion' or 'product'
  export let userId;

  const dispatch = createEventDispatcher();

  let reason = '';
  let isLoading = false;
  let error = '';

  const reasons = [
    "No longer valid / Expired",
    "Out of stock",
    "Incorrect price/info",
    "Duplicate entry",
    "Store closed",
    "Other"
  ];

  async function handleSubmit() {
    if (!reason) {
      error = "Please select a reason.";
      return;
    }
    isLoading = true;
    error = '';

    try {
      const response = await authFetch(getApiUrl('/reports'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ targetId, targetType, userId, reason })
      });

      if (response.status === 409) {
        throw new Error("You have already reported this item.");
      }
      if (!response.ok) {
        throw new Error("Failed to submit report.");
      }
      
      dispatch('success');
      close();
    } catch (e) {
      error = e.message;
    } finally {
      isLoading = false;
    }
  }

  function close() {
    showModal = false;
    reason = '';
    error = '';
  }
</script>

{#if showModal}
  <div class="modal-backdrop" on:click={close}>
    <div class="modal-content" on:click|stopPropagation>
      <h3>Report Issue</h3>
      <p>Why are you reporting this?</p>
      
      <div class="options">
        {#each reasons as r}
          <label class="radio-option">
            <input type="radio" bind:group={reason} value={r}>
            {r}
          </label>
        {/each}
      </div>

      {#if error} <p class="error">{error}</p> {/if}

      <div class="actions">
        <button class="secondary" on:click={close} disabled={isLoading}>Cancel</button>
        <button class="primary" on:click={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Submitting...' : 'Submit Report'}
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-backdrop {
    position: fixed; top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(0,0,0,0.5); display: flex;
    justify-content: center; align-items: center; z-index: 2000;
  }
  .modal-content {
    background: white; padding: 2rem; border-radius: 8px;
    width: 90%; max-width: 400px;
  }
  .options { display: flex; flex-direction: column; gap: 0.8rem; margin: 1rem 0; }
  .radio-option { display: flex; align-items: center; gap: 0.5rem; cursor: pointer; }
  .actions { display: flex; justify-content: flex-end; gap: 1rem; margin-top: 1.5rem; }
  button { padding: 0.6rem 1.2rem; border-radius: 4px; border: none; cursor: pointer; font-size: 1rem; }
  .primary { background-color: #dc3545; color: white; }
  .secondary { background-color: #6c757d; color: white; }
  .error { color: #dc3545; font-size: 0.9rem; margin-top: 0.5rem; }
</style>